import { render } from "./CompanyInformation.vue?vue&type=template&id=6fc2ed2b&scoped=true&ts=true"
import script from "./CompanyInformation.vue?vue&type=script&lang=ts"
export * from "./CompanyInformation.vue?vue&type=script&lang=ts"

import "./CompanyInformation.vue?vue&type=style&index=0&id=6fc2ed2b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fc2ed2b"]])

export default __exports__